import axios from 'axios';
import { connect } from "react-redux";
import React, { Component } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { compose } from "redux";
import { BASEURL, FILE_DOWNLOAD_URL } from '../Config';
import { addProductsToCart } from '../modules/actions';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';

class ShopSingle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            product: {},
            photoIndex: 0,
            isOpen: false
        }
    }
    componentDidMount() {
        console.log('id', this.props.location.state.id);
        axios.get(`${BASEURL}/api/v1/product/fetchByPid/${this.props.location.state.id}`)
            .then(res => {
                if (res.status === 200) {
                    console.log('res.data', res.data);
                    let data = res.data;
                    this.setState({
                        product: data
                    })
                }
            })
            .catch(err => {
                console.log('fetchByPid err', err);
            })
    }

    handleAddTocart() {
        let data = {};
        data.id = this.state.product._id;
        data.price = this.state.product.price;
        data.thb = this.state.product.thb;
        data.pname = this.state.product.pname;
        data.pTotal = this.state.product.price;
        data.prodCount = 1;
        this.props.addProductsToCart(data);
        this.props.history.push({
            pathname: "cart"
        });
    }
    render() {
        const { photoIndex, isOpen } = this.state;
        return (
            <div className="site-wrap">
                <Header />
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><a href="shop">Shop</a> <span className="mx-2 mb-0">/</span> <strong className="text-black">{this.state.product.pname}</strong></div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 ">
                                <img src={`${FILE_DOWNLOAD_URL}/${this.state.product.thb}`} alt="Image" className='productThb mb-2' />
                            </div>
                            <div className="col-md-6">
                                <h2 className="text-black">{this.state.product.pname}</h2>
                                <p className="mb-4">{this.state.product.desc}</p>
                                <hr></hr>
                                <p><strong className="text-primary h4">₹{this.state.product.price}</strong></p>
                                {/* <div className="mb-5">
                                    <div className="input-group mb-3" style={{ maxWidth: '120px' }}>
                                        <div className="input-group-prepend">
                                            <button className="btn btn-outline-primary js-btn-minus" type="button">−</button>
                                        </div>
                                        <input type="text" className="form-control text-center" defaultValue={1} placeholder aria-label="Example text with button addon" aria-describedby="button-addon1" />
                                        <div className="input-group-append">
                                            <button className="btn btn-outline-primary js-btn-plus" type="button">+</button>
                                        </div>
                                    </div>
                                </div> */}
                                <p><a onClick={() => this.handleAddTocart()} className="buy-now btn btn-sm btn-primary form-control">Add To Cart</a></p>
                                <hr></hr>
                                <p><strong className='text-black'>Code: </strong>{this.state.product.code}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="site-section block-3 site-blocks-2 bg-light">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-7 site-section-heading text-center pt-4">
                                <h2>Featured Products</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="nonloop-block-3 owl-carousel">
                                    <div className="item">
                                        <div className="block-4 text-center">
                                            <figure className="block-4-image">
                                                <img src="images/cloth_1.jpg" alt="Image placeholder" className="img-fluid" />
                                            </figure>
                                            <div className="block-4-text p-4">
                                                <h3><a href="#">Tank Top</a></h3>
                                                <p className="mb-0">Finding perfect t-shirt</p>
                                                <p className="text-primary font-weight-bold">$50</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="block-4 text-center">
                                            <figure className="block-4-image">
                                                <img src="images/shoe_1.jpg" alt="Image placeholder" className="img-fluid" />
                                            </figure>
                                            <div className="block-4-text p-4">
                                                <h3><a href="#">Corater</a></h3>
                                                <p className="mb-0">Finding perfect products</p>
                                                <p className="text-primary font-weight-bold">$50</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="block-4 text-center">
                                            <figure className="block-4-image">
                                                <img src="images/cloth_2.jpg" alt="Image placeholder" className="img-fluid" />
                                            </figure>
                                            <div className="block-4-text p-4">
                                                <h3><a href="#">Polo Shirt</a></h3>
                                                <p className="mb-0">Finding perfect products</p>
                                                <p className="text-primary font-weight-bold">$50</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="block-4 text-center">
                                            <figure className="block-4-image">
                                                <img src="images/cloth_3.jpg" alt="Image placeholder" className="img-fluid" />
                                            </figure>
                                            <div className="block-4-text p-4">
                                                <h3><a href="#">T-Shirt Mockup</a></h3>
                                                <p className="mb-0">Finding perfect products</p>
                                                <p className="text-primary font-weight-bold">$50</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="block-4 text-center">
                                            <figure className="block-4-image">
                                                <img src="images/shoe_1.jpg" alt="Image placeholder" className="img-fluid" />
                                            </figure>
                                            <div className="block-4-text p-4">
                                                <h3><a href="#">Corater</a></h3>
                                                <p className="mb-0">Finding perfect products</p>
                                                <p className="text-primary font-weight-bold">$50</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <Footer />
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    addProductsToCart: (products) => dispatch(addProductsToCart(products))
});

export default compose(connect(null, mapDispatchToProps))(ShopSingle);